module.exports = __webpack_public_path__ + "img/solution_6.71e0af45.png";